import BasicContentCTABanner from './BasicContentCTABanner';

export { type BasicContentCTABannerProps } from './BasicContentCTABanner';
export default BasicContentCTABanner;
